/* eslint no-param-reassign: ["error", { "props": false }], no-return-assign: "error" */
import React, { PureComponent } from 'react';

import {
  StyledSearchFilterWrapper,
  StyledSearchFilterLabel,
  StyledSFRowName,
  StyledSFRowSurname,
  StyledSFRowDepartment,
  StyledSFRowTitle,
  StyledRemoveFilters,
  StyledBtnFilters,
  StyledIconClose,
  StyledButtonDesktop,
  StyledRowInputs,
  StyledButtonsModal,
  StyledButton,
  StyledAutocomplete,
  StyledAutocompleteList,
  StyledAutocompleteItem,
  StyledAutocompleteButton,
  StyledInput,
  StyledSFRowEmployeeId
} from './style';
import { getDepartmentNameHCM } from '../../../utils/apiDepartment';

import { Close } from '../../../../assets/images/index';

const resetValues = {
  validname: true,
  validlastname: true,
  validDepartment: true,
  name: undefined,
  lastname: undefined,
  department: undefined,
  employeeId: undefined
};
const initialValues = {
  ...resetValues,
  departmentList: undefined,
  showAutocomplete: false,
  validForm: false
};

class FilterForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = initialValues;
    this.inputFields = undefined;
  }

  componentDidMount() {
    this.inputFields = Array.from(document.querySelectorAll('input'));
  }

  onInputDepartment = value => {
    const searchString = value || '';
    const { department } = this.state;
    this.setState({ department: searchString });
    if (searchString !== '') {
      this.setState({ showAutocomplete: true });
    } else {
      this.setState({ showAutocomplete: false, validDepartment: false });
    }
    getDepartmentNameHCM({ name: searchString })
      .then(dpto => {
        if (dpto && dpto.total > 0) {
          this.setState({ departmentList: dpto }, () =>
            this.validateDepartment(department)
          );
        }
      })
      .catch(error => {
        throw error;
      });
  };

  getRandomKey = () => Math.round(Math.random() * 999999);

  getErrors = () => {
    const { validname, validlastname, validDepartment } = this.state;

    if (validname && validlastname && validDepartment) {
      this.setState({
        validForm: true
      });
    } else {
      this.setState({
        validForm: false
      });
    }
  };

  validateData = (name, value) => {
    switch (name) {
      case 'name':
      case 'lastname':
      case 'department':
        return value.search(/[0-9]/) === -1;
      case 'employeeId':
      case 'idDepartment':
        return !Number.isNaN(Number(value));
      default:
        return false;
    }
  };

  validateDepartment = dataInput => {
    const { departmentList } = this.state;
    if (!dataInput || dataInput === '') {
      return true;
    }
    if (departmentList && departmentList.total > 0) {
      this.setState(
        {
          validDepartment: departmentList.content.some(
            el => el.name === dataInput
          )
        },
        () => this.getErrors()
      );
      return departmentList.content.some(el => el.name === dataInput);
    }

    return false;
  };

  fillClick = () => {
    const { setFilter } = this.props;

    let filter;
    if (this.inputFields && this.inputFields.length > 0) {
      filter = {};
      this.inputFields.map(el => {
        if (el.value !== '') {
          const { value, name } = el;
          if (name === 'department') {
            filter.departmentName = this.state.department;
          }
          if (this.validateData(name, value)) {
            filter[name] = value;
          }
        }
        return null;
      });
    }
    setFilter(filter);
    return filter;
  };

  findFilters = () => {
    if (this.inputFields) {
      this.inputFields.some(el => el.value !== '' && el.value !== undefined);
      return true;
    }
    return false;
  };

  validateField = (value, evt) => {
    const { name } = evt.target;
    const result = value === '' || this.validateData(name, value);
    this.setState({ [`valid${name}`]: result, [name]: value }, () =>
      this.getErrors()
    );
  };

  selectDepartment = nameDepartment => {
    this.setState(
      {
        department: nameDepartment,
        showAutocomplete: false
      },
      () => this.validateDepartment(nameDepartment)
    );
  };

  render() {
    const { onClick, closeModal, modalActive, filter } = this.props;
    const {
      departmentList,
      validname,
      validlastname,
      validForm,
      showAutocomplete
    } = this.state;

    return (
      <React.Fragment>
        <StyledSearchFilterWrapper modalActive={modalActive}>
          <StyledSFRowTitle>buscar y filtrar</StyledSFRowTitle>
          <StyledRowInputs>
            <StyledSFRowName>
              <StyledSearchFilterLabel id="name" for="name">
                Nombre
              </StyledSearchFilterLabel>
              <StyledInput
                error={!validname && 'números no permitidos'}
                onChange={this.validateField}
                id="inputName"
                name="name"
                value={this.state.name}
                placeholder={filter.name}
              />
            </StyledSFRowName>
            <StyledSFRowSurname>
              <StyledSearchFilterLabel id="lastname" for="lastname">
                Apellidos
              </StyledSearchFilterLabel>
              <StyledInput
                error={!validlastname && 'números no permitidos'}
                onChange={this.validateField}
                name="lastname"
                value={this.state.lastname}
                placeholder={filter.lastname}
              />
            </StyledSFRowSurname>
            <StyledSFRowEmployeeId>
              <StyledSearchFilterLabel id="employeeId" for="employeeId">
                Id. Empleado
              </StyledSearchFilterLabel>
              <StyledInput
                name="employeeId"
                onChange={this.validateField}
                value={this.state.employeeId}
                placeholder={filter.employeeId}
              />
            </StyledSFRowEmployeeId>
            <StyledSFRowDepartment>
              <StyledSearchFilterLabel id="department" for="department">
                Departamento
              </StyledSearchFilterLabel>
              <StyledInput
                name="department"
                onChange={this.onInputDepartment}
                value={this.state.department}
                error={
                  !this.validateDepartment(this.state.department) &&
                  'El departamento no existe'
                }
                autoComplete="off"
                placeholder={filter.departmentName}
              />
              {departmentList && departmentList.total > 0 && showAutocomplete && (
                <StyledAutocomplete>
                  <StyledAutocompleteList>
                    {departmentList.content.map(item => (
                      <StyledAutocompleteItem key={this.getRandomKey()}>
                        <StyledAutocompleteButton
                          onClick={() => this.selectDepartment(item.name)}
                        >
                          {item.name}
                        </StyledAutocompleteButton>
                      </StyledAutocompleteItem>
                    ))}
                  </StyledAutocompleteList>
                </StyledAutocomplete>
              )}
            </StyledSFRowDepartment>
            <div />
          </StyledRowInputs>
          {Object.keys(filter).length !== 0 && (
            <StyledRemoveFilters>
              <StyledIconClose svg={Close} />
              <StyledBtnFilters
                onClick={() => {
                  this.inputFields.map(element => (element.value = ''));
                  this.setState(resetValues);
                  onClick(this.fillClick)();
                }}
              >
                Borrar filtros
              </StyledBtnFilters>
            </StyledRemoveFilters>
          )}
          {modalActive ? (
            <StyledButtonsModal>
              <StyledButton
                onClick={closeModal}
                modalActive={modalActive}
                modal
              >
                Cancelar
              </StyledButton>
              <StyledButton
                secondary
                onClick={onClick(this.fillClick)}
                disabled={!validForm}
              >
                Guardar
              </StyledButton>
            </StyledButtonsModal>
          ) : (
            <StyledButtonDesktop
              onClick={onClick(this.fillClick)}
              modalActive={modalActive}
              disabled={!validForm}
            >
              Buscar
            </StyledButtonDesktop>
          )}
        </StyledSearchFilterWrapper>
      </React.Fragment>
    );
  }
}

export default FilterForm;
